export default __webpack_public_path__ + "static/media/call.4cd0476d.svg";